<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
  font-family: 'robotoregular';
  padding: 0;
  margin: 0;
}

.mrg-20 {
  padding-bottom: 20px;
}

.mrg-40 {
  padding-bottom: 40px;
}

* {
  letter-spacing: 0.5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue